import { httpCreate } from './http';

const http = httpCreate('/srv/sign-activity');

export const signActivity = {
	//新建签到活动
	addSign(activityId, data) {
		return http.post(`/${activityId}`, data);
	},
	//修改签到活动
	updateSign(id, data) {
		return http.put(`/${id}`, data);
	},
	//签到活动列表
	list(id, params) {
		return http.get(`/list/${id}`, { params });
	},
	//删除签到活动
	deleteSign(id) {
		return http.delete(`/${id}`);
	},
	//手动开启签到活动
	openSign(id) {
		return http.post(`/${id}/open`);
	},
	//手动关闭活动
	closeSign(id) {
		return http.post(`/${id}/close`);
	},
	//签到人员列表
	joinList(id, params) {
		return http.get(`/participantList/${id}`, { params });
	},
	//导出签到人员列表
	exportList(id) {
		return `/srv/sign-activity/export/${id}`;
	},
};
